import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-base">
        <div className="font-mono text-white/40 text-sm animate-pulse">loading arena…</div>
      </div>
    );
  }
  if (!user) {
    const next = location.pathname + location.search;
    const to = next.startsWith("/join/") ? `/auth?mode=register&next=${encodeURIComponent(next)}` : "/auth";
    return <Navigate to={to} replace />;
  }
  return children;
};
